import i18n from '@pro/common/i18n/i18n';
import { getTimezone } from '@/Common/api/site';
import { getSiteTimeZoneTxt } from '@/Common/api/site';
import { mutations } from '@/Common/libs/store';
// const i18n = {
//   t: function(str) {
//     return str;
//   },
// };
// const LatinAmericaRobotUrl = 'https://hik-e.hikccs.com/s/hikvisionlatambot';
// const CentralAsiaOuterCaucasusRobotUrl = 'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158253045876482&receiveId=&sourceId=209&lan=en';
const CountriesItem = [
  {
    index: 0,
    label: i18n.t('Austria'),
    phoneAreaCode: 43,
    labelKey: 'Austria',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 1,
    label: i18n.t('Belgium'),
    phoneAreaCode: 32,
    labelKey: 'Belgium',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 2,
    label: i18n.t('Croatia'),
    phoneAreaCode: 385,
    labelKey: 'Croatia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 3,
    label: i18n.t('Czech'),
    phoneAreaCode: 420,
    labelKey: 'Czech',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1625126465224104&receiveId=&sourceId=223&lan=en'
  },
  {
    index: 4,
    label: i18n.t('Denmark'),
    phoneAreaCode: 45,
    labelKey: 'Denmark',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 5,
    label: i18n.t('Finland'),
    phoneAreaCode: 358,
    labelKey: 'Finland',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 6,
    label: i18n.t('France'),
    phoneAreaCode: 33,
    labelKey: 'France',
    newIndex: 6,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=219&lan=en'
  },
  {
    index: 7,
    label: i18n.t('Germany'),
    phoneAreaCode: 49,
    labelKey: 'Germany',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1658391310929130&receiveId=&sourceId=254&lan=en'
  },
  {
    index: 8,
    label: i18n.t('Greece'),
    phoneAreaCode: 30,
    labelKey: 'Greece',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 9,
    label: i18n.t('Hungary'),
    phoneAreaCode: 36,
    labelKey: 'Hungary',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 10,
    label: i18n.t('Italy'),
    phoneAreaCode: 39,
    labelKey: 'Italy',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 11,
    label: i18n.t('Netherlands'),
    phoneAreaCode: 31,
    labelKey: 'Netherlands',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1629364912062108&receiveId=&sourceId=231&lan=en'
  },
  {
    index: 12,
    label: i18n.t('Norway'),
    phoneAreaCode: 47,
    labelKey: 'Norway',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 13,
    label: i18n.t('Poland'),
    phoneAreaCode: 48,
    labelKey: 'Poland',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 14,
    label: i18n.t('Portugal'),
    phoneAreaCode: 351,
    labelKey: 'Portugal',
    newIndex: 14,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1612232121517102&receiveId=&sourceId=270&lan=en'
  },
  {
    index: 15,
    label: i18n.t('Romania'),
    phoneAreaCode: 40,
    labelKey: 'Romania',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 16,
    label: i18n.t('Serbia'),
    phoneAreaCode: 381,
    labelKey: 'Serbia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 17,
    label: i18n.t('Slovak'),
    phoneAreaCode: 421,
    labelKey: 'Slovak',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 18,
    label: i18n.t('Slovenia'),
    phoneAreaCode: 386,
    labelKey: 'Slovenia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 19,
    label: i18n.t('Spain'),
    phoneAreaCode: 34,
    labelKey: 'Spain',
    newIndex: 19,
    FAQUrl: 'http://enpinfodata.hikvision.com/analysisQR/showQR/3ad0321b.html',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=157611401373480&receiveId=&sourceId=271&lan=en'
  },
  {
    index: 20,
    label: i18n.t('Sweden'),
    phoneAreaCode: 46,
    labelKey: 'Sweden',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 21,
    label: i18n.t('Switzerland'),
    phoneAreaCode: 41,
    labelKey: 'Switzerland',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 22,
    label: i18n.t('UnitedKingdom'),
    phoneAreaCode: 44,
    labelKey: 'UnitedKingdom',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 23,
    label: i18n.t('UnitedStates'),
    phoneAreaCode: 1,
    labelKey: 'UnitedStates',
    TPPUrl: 'https://us.hikvision.com/en/partners/technology-partners',
    eLearningUrl: 'https://www.hikvisionlearning.com',
    FAQUrl: 'https://info.hikvision.com/hdp-faq',
    youtubeLink: 'https://www.youtube.com/@HikvisionUSAinc',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1637128797880120&receiveId=&sourceId=269&lan=en'
  },
  {
    index: 24,
    label: i18n.t('Canada'),
    phoneAreaCode: 1,
    labelKey: 'Canada',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 25,
    label: i18n.t('Afghanistan'),
    phoneAreaCode: 93,
    labelKey: 'Afghanistan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  // {
  //   index: 26,
  //   label: i18n.t('AfricaOther'),
  //   phoneAreaCode: 0,
  //   labelKey: "AfricaOther",
  //   robotUrl: "https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en",
  // },
  {
    index: 27,
    label: i18n.t('Albania'),
    phoneAreaCode: 355,
    labelKey: 'Albania',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 28,
    label: i18n.t('Algeria'),
    phoneAreaCode: 213,
    labelKey: 'Algeria',
    newIndex: 28,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 29,
    label: i18n.t('Andorra'),
    phoneAreaCode: 376,
    labelKey: 'Andorra',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 30,
    label: i18n.t('Angola'),
    phoneAreaCode: 244,
    labelKey: 'Angola',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 31,
    label: i18n.t('Anguilla'),
    phoneAreaCode: 1264,
    labelKey: 'Anguilla',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 32,
    label: i18n.t('Antarctica'),
    phoneAreaCode: 0,
    labelKey: 'Antarctica',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 33,
    label: i18n.t('AntiguaAndBarbuda'),
    phoneAreaCode: 1268,
    labelKey: 'AntiguaAndBarbuda',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 34,
    label: i18n.t('Argentina'),
    phoneAreaCode: 54,
    labelKey: 'Argentina',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 35,
    label: i18n.t('Armenia'),
    phoneAreaCode: 374,
    labelKey: 'Armenia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158253045876482&receiveId=&sourceId=209&lan=en'
  },
  {
    index: 36,
    label: i18n.t('Aruba'),
    phoneAreaCode: 297,
    labelKey: 'Aruba',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  // {
  //   index: 37,
  //   label: i18n.t('Asia'),
  //   phoneAreaCode: 0,
  //   labelKey: "Asia",
  //   robotUrl: "https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en",
  // },
  // {
  //   index: 38,
  //   label: i18n.t('AsiaOther'),
  //   phoneAreaCode: 0,
  //   labelKey: "AsiaOther",
  //   robotUrl: "https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en",
  // },
  {
    index: 39,
    label: i18n.t('Australia'),
    phoneAreaCode: 61,
    labelKey: 'Australia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 40,
    label: i18n.t('Azerbaijan'),
    phoneAreaCode: 994,
    labelKey: 'Azerbaijan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158253045876482&receiveId=&sourceId=209&lan=en'
  },
  {
    index: 41,
    label: i18n.t('Bahamas'),
    phoneAreaCode: 1242,
    labelKey: 'Bahamas',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 42,
    label: i18n.t('Bahrain'),
    phoneAreaCode: 973,
    labelKey: 'Bahrain',
    newIndex: 42,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 43,
    label: i18n.t('Bangladesh'),
    phoneAreaCode: 880,
    labelKey: 'Bangladesh',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 44,
    label: i18n.t('Barbados'),
    phoneAreaCode: 1246,
    labelKey: 'Barbados',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 45,
    label: i18n.t('Belarus'),
    phoneAreaCode: 375,
    labelKey: 'Belarus',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 46,
    label: i18n.t('Belize'),
    phoneAreaCode: 501,
    labelKey: 'Belize',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 47,
    label: i18n.t('Benin'),
    phoneAreaCode: 229,
    labelKey: 'Benin',
    newIndex: 47,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 48,
    label: i18n.t('Bermuda'),
    phoneAreaCode: 1441,
    labelKey: 'Bermuda',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 49,
    label: i18n.t('Bhutan'),
    phoneAreaCode: 975,
    labelKey: 'Bhutan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 50,
    label: i18n.t('Bolivia'),
    phoneAreaCode: 591,
    labelKey: 'Bolivia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 51,
    label: i18n.t('Bonaire'),
    phoneAreaCode: 5997,
    labelKey: 'Bonaire',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 52,
    label: i18n.t('BosniaAndHerzegovina'),
    phoneAreaCode: 387,
    labelKey: 'BosniaAndHerzegovina',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 53,
    label: i18n.t('Botswana'),
    phoneAreaCode: 267,
    labelKey: 'Botswana',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 54,
    label: i18n.t('Brazil'),
    phoneAreaCode: 55,
    labelKey: 'Brazil',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1612232121517102&receiveId=&sourceId=218&lan=en',
    eLearningUrl: 'https://elearning.hikvision.com/br/'
  },
  {
    index: 55,
    label: i18n.t('Brunei'),
    phoneAreaCode: 673,
    labelKey: 'Brunei',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 56,
    label: i18n.t('Bulgaria'),
    phoneAreaCode: 359,
    labelKey: 'Bulgaria',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 57,
    label: i18n.t('BurkinaFaso'),
    phoneAreaCode: 226,
    labelKey: 'BurkinaFaso',
    newIndex: 57,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 58,
    label: i18n.t('Burma'),
    phoneAreaCode: 95,
    labelKey: 'Burma',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 59,
    label: i18n.t('Burundi'),
    phoneAreaCode: 257,
    labelKey: 'Burundi',
    newIndex: 59,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 60,
    label: i18n.t('Cambodia'),
    phoneAreaCode: 855,
    labelKey: 'Cambodia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 61,
    label: i18n.t('Cameroon'),
    phoneAreaCode: 237,
    labelKey: 'Cameroon',
    newIndex: 61,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 62,
    label: i18n.t('CapeVerde'),
    phoneAreaCode: 238,
    labelKey: 'CapeVerde',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 63,
    label: i18n.t('CaymanIslands'),
    phoneAreaCode: 1345,
    labelKey: 'CaymanIslands',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 64,
    label: i18n.t('CentralAfricanRepublic'),
    phoneAreaCode: 236,
    labelKey: 'CentralAfricanRepublic',
    newIndex: 64,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 65,
    label: i18n.t('Chad'),
    phoneAreaCode: 235,
    labelKey: 'Chad',
    newIndex: 65,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 66,
    label: i18n.t('Chile'),
    phoneAreaCode: 56,
    labelKey: 'Chile',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 67,
    label: i18n.t('Colombia'),
    phoneAreaCode: 57,
    labelKey: 'Colombia',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 68,
    label: i18n.t('Comoros'),
    phoneAreaCode: 269,
    labelKey: 'Comoros',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 69,
    label: i18n.t('Congo_Brazzaville'),
    phoneAreaCode: 242,
    labelKey: 'Congo_Brazzaville',
    newIndex: 69,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 70,
    label: i18n.t('Congo_Kinshasa'),
    phoneAreaCode: 243,
    labelKey: 'Congo_Kinshasa',
    newIndex: 70,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 71,
    label: i18n.t('CookIslands'),
    phoneAreaCode: 682,
    labelKey: 'CookIslands',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 72,
    label: i18n.t('CostaRica'),
    phoneAreaCode: 506,
    labelKey: 'CostaRica',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 73,
    label: i18n.t('CoteD_Ivoire'),
    phoneAreaCode: 225,
    labelKey: 'CoteD_Ivoire',
    newIndex: 73,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 74,
    label: i18n.t('Curacao'),
    phoneAreaCode: 5999,
    labelKey: 'Curacao',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 75,
    label: i18n.t('Cyprus'),
    phoneAreaCode: 357,
    labelKey: 'Cyprus',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 76,
    label: i18n.t('Djibouti'),
    phoneAreaCode: 253,
    labelKey: 'Djibouti',
    newIndex: 76,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 77,
    label: i18n.t('Dominica'),
    phoneAreaCode: 1767,
    labelKey: 'Dominica',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 78,
    label: i18n.t('DominicanRepublic'),
    phoneAreaCode: 1,
    labelKey: 'DominicanRepublic',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 79,
    label: i18n.t('Ecuador'),
    phoneAreaCode: 593,
    labelKey: 'Ecuador',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 80,
    label: i18n.t('Egypt'),
    phoneAreaCode: 20,
    labelKey: 'Egypt',
    newIndex: 80,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 81,
    label: i18n.t('ElSalvador'),
    phoneAreaCode: 503,
    labelKey: 'ElSalvador',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 82,
    label: i18n.t('EquatorialGuinea'),
    phoneAreaCode: 240,
    labelKey: 'EquatorialGuinea',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 83,
    label: i18n.t('Eritrea'),
    phoneAreaCode: 291,
    labelKey: 'Eritrea',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 84,
    label: i18n.t('Estonia'),
    phoneAreaCode: 372,
    labelKey: 'Estonia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 85,
    label: i18n.t('Ethiopia'),
    phoneAreaCode: 251,
    labelKey: 'Ethiopia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  // {
  //   index: 86,
  //   label: i18n.t('EuropeOther'),
  //   phoneAreaCode: 0,
  //   labelKey: "EuropeOther",
  //   robotUrl: "https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en",
  // },
  {
    index: 87,
    label: i18n.t('FalklandIslands_Malvinas'),
    phoneAreaCode: 500,
    labelKey: 'FalklandIslands_Malvinas',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 88,
    label: i18n.t('Fiji'),
    phoneAreaCode: 679,
    labelKey: 'Fiji',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 89,
    label: i18n.t('FrenchGuiana'),
    phoneAreaCode: 594,
    labelKey: 'FrenchGuiana',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 90,
    label: i18n.t('FrenchPolynesia'),
    phoneAreaCode: 689,
    labelKey: 'FrenchPolynesia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 91,
    label: i18n.t('Gabon'),
    phoneAreaCode: 241,
    labelKey: 'Gabon',
    newIndex: 91,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 92,
    label: i18n.t('Gambia'),
    phoneAreaCode: 220,
    labelKey: 'Gambia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 93,
    label: i18n.t('Georgia'),
    phoneAreaCode: 995,
    labelKey: 'Georgia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158253045876482&receiveId=&sourceId=209&lan=en'
  },
  {
    index: 94,
    label: i18n.t('Ghana'),
    phoneAreaCode: 233,
    labelKey: 'Ghana',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 95,
    label: i18n.t('Greenland'),
    phoneAreaCode: 299,
    labelKey: 'Greenland',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 96,
    label: i18n.t('Grenada'),
    phoneAreaCode: 473,
    labelKey: 'Grenada',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 97,
    label: i18n.t('Guadeloupe'),
    phoneAreaCode: 590,
    labelKey: 'Guadeloupe',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 98,
    label: i18n.t('Guatemala'),
    phoneAreaCode: 502,
    labelKey: 'Guatemala',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 99,
    label: i18n.t('Guinea'),
    phoneAreaCode: 224,
    labelKey: 'Guinea',
    newIndex: 99,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 100,
    label: i18n.t('Guinea_Bissau'),
    phoneAreaCode: 245,
    labelKey: 'Guinea_Bissau',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 101,
    label: i18n.t('Guyana'),
    phoneAreaCode: 592,
    labelKey: 'Guyana',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 102,
    label: i18n.t('Haiti'),
    phoneAreaCode: 509,
    labelKey: 'Haiti',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 103,
    label: i18n.t('Honduras'),
    phoneAreaCode: 504,
    labelKey: 'Honduras',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 104,
    label: i18n.t('HongKong_China'),
    phoneAreaCode: 852,
    labelKey: 'HongKong_China',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 105,
    label: i18n.t('Iceland'),
    phoneAreaCode: 354,
    labelKey: 'Iceland',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 106,
    label: i18n.t('India'),
    phoneAreaCode: 91,
    labelKey: 'India',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 107,
    label: i18n.t('Indonesia'),
    phoneAreaCode: 62,
    labelKey: 'Indonesia',
    newIndex: 107,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=157319266721778&receiveId=&sourceId=197&lan=en'
  },
  {
    index: 108,
    label: i18n.t('Iraq'),
    phoneAreaCode: 964,
    labelKey: 'Iraq',
    newIndex: 108,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 109,
    label: i18n.t('Ireland'),
    phoneAreaCode: 353,
    labelKey: 'Ireland',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 110,
    label: i18n.t('Israel'),
    phoneAreaCode: 972,
    labelKey: 'Israel',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 111,
    label: i18n.t('Jamaica'),
    phoneAreaCode: 1876,
    labelKey: 'Jamaica',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 112,
    label: i18n.t('Japan'),
    phoneAreaCode: 81,
    labelKey: 'Japan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 113,
    label: i18n.t('Jordan'),
    phoneAreaCode: 962,
    labelKey: 'Jordan',
    newIndex: 113,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 114,
    label: i18n.t('Kazakstan'),
    phoneAreaCode: 7,
    labelKey: 'Kazakstan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158253045876482&receiveId=&sourceId=209&lan=en'
  },
  {
    index: 115,
    label: i18n.t('Kenya'),
    phoneAreaCode: 254,
    labelKey: 'Kenya',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 116,
    label: i18n.t('Kiribati'),
    phoneAreaCode: 686,
    labelKey: 'Kiribati',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 117,
    label: i18n.t('Korea'),
    phoneAreaCode: 82,
    labelKey: 'Korea',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1635918689381118&receiveId=&sourceId=239&lan=en'
  },
  {
    index: 118,
    label: i18n.t('Kosovo'),
    phoneAreaCode: 383,
    labelKey: 'Kosovo',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 119,
    label: i18n.t('Kuwait'),
    phoneAreaCode: 965,
    labelKey: 'Kuwait',
    newIndex: 119,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 120,
    label: i18n.t('Kyrgyzstan'),
    phoneAreaCode: 996,
    labelKey: 'Kyrgyzstan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158253045876482&receiveId=&sourceId=209&lan=en'
  },
  {
    index: 121,
    label: i18n.t('Laos'),
    phoneAreaCode: 856,
    labelKey: 'Laos',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 122,
    label: i18n.t('Latvia'),
    phoneAreaCode: 371,
    labelKey: 'Latvia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 123,
    label: i18n.t('Lebanon'),
    phoneAreaCode: 961,
    labelKey: 'Lebanon',
    newIndex: 123,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 124,
    label: i18n.t('Lesotho'),
    phoneAreaCode: 266,
    labelKey: 'Lesotho',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 125,
    label: i18n.t('Liberia'),
    phoneAreaCode: 231,
    labelKey: 'Liberia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 126,
    label: i18n.t('Libya'),
    phoneAreaCode: 218,
    labelKey: 'Libya',
    newIndex: 126,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 127,
    label: i18n.t('Liechtenstein'),
    phoneAreaCode: 423,
    labelKey: 'Liechtenstein',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 128,
    label: i18n.t('Lithuania'),
    phoneAreaCode: 370,
    labelKey: 'Lithuania',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 129,
    label: i18n.t('Luxembourg'),
    phoneAreaCode: 352,
    labelKey: 'Luxembourg',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 130,
    label: i18n.t('Macao_China'),
    phoneAreaCode: 853,
    labelKey: 'Macao_China',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 131,
    label: i18n.t('NorthMacedonia'),
    phoneAreaCode: 389,
    labelKey: 'NorthMacedonia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 132,
    label: i18n.t('Madagascar'),
    phoneAreaCode: 261,
    labelKey: 'Madagascar',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 133,
    label: i18n.t('MainlandChina'),
    phoneAreaCode: 86,
    labelKey: 'MainlandChina',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 134,
    label: i18n.t('Malaysia'),
    phoneAreaCode: 60,
    labelKey: 'Malaysia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 135,
    label: i18n.t('Malawi'),
    phoneAreaCode: 265,
    labelKey: 'Malawi',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 136,
    label: i18n.t('Maldives'),
    phoneAreaCode: 960,
    labelKey: 'Maldives',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 137,
    label: i18n.t('Mali'),
    phoneAreaCode: 223,
    labelKey: 'Mali',
    newIndex: 137,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 138,
    label: i18n.t('Malta'),
    phoneAreaCode: 356,
    labelKey: 'Malta',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 139,
    label: i18n.t('MarshallIslands'),
    phoneAreaCode: 692,
    labelKey: 'MarshallIslands',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 140,
    label: i18n.t('Martinique'),
    phoneAreaCode: 596,
    labelKey: 'Martinique',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 141,
    label: i18n.t('Mauritania'),
    phoneAreaCode: 222,
    labelKey: 'Mauritania',
    newIndex: 141,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 142,
    label: i18n.t('Mauritius'),
    phoneAreaCode: 230,
    labelKey: 'Mauritius',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 143,
    label: i18n.t('Mexico'),
    phoneAreaCode: 52,
    labelKey: 'Mexico',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 144,
    label: i18n.t('Micronesia'),
    phoneAreaCode: 691,
    labelKey: 'Micronesia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 145,
    label: i18n.t('Moldova'),
    phoneAreaCode: 373,
    labelKey: 'Moldova',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158253045876482&receiveId=&sourceId=209&lan=en'
  },
  {
    index: 146,
    label: i18n.t('Monaco'),
    phoneAreaCode: 377,
    labelKey: 'Monaco',
    newIndex: 146,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=219&lan=en'
  },
  {
    index: 147,
    label: i18n.t('Mongolia'),
    phoneAreaCode: 976,
    labelKey: 'Mongolia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 148,
    label: i18n.t('Montenegro'),
    phoneAreaCode: 382,
    labelKey: 'Montenegro',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 149,
    label: i18n.t('Montserrat'),
    phoneAreaCode: 1664,
    labelKey: 'Montserrat',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 150,
    label: i18n.t('Morocco'),
    phoneAreaCode: 212,
    labelKey: 'Morocco',
    newIndex: 150,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 151,
    label: i18n.t('Mozambique'),
    phoneAreaCode: 258,
    labelKey: 'Mozambique',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 152,
    label: i18n.t('Namibia'),
    phoneAreaCode: 264,
    labelKey: 'Namibia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 153,
    label: i18n.t('Nauru'),
    phoneAreaCode: 674,
    labelKey: 'Nauru',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 154,
    label: i18n.t('Nepal'),
    phoneAreaCode: 977,
    labelKey: 'Nepal',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 155,
    label: i18n.t('NewCaledonia'),
    phoneAreaCode: 687,
    labelKey: 'NewCaledonia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 156,
    label: i18n.t('NewZealand'),
    phoneAreaCode: 64,
    labelKey: 'NewZealand',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 157,
    label: i18n.t('Nicaragua'),
    phoneAreaCode: 505,
    labelKey: 'Nicaragua',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 158,
    label: i18n.t('Niger'),
    phoneAreaCode: 227,
    labelKey: 'Niger',
    newIndex: 158,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 159,
    label: i18n.t('Nigeria'),
    phoneAreaCode: 234,
    labelKey: 'Nigeria',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  // {
  //   index: 160,
  //   label: i18n.t('OceaniaOther'),
  //   phoneAreaCode: 0,
  //   labelKey: "OceaniaOther",
  //   robotUrl: "https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en",
  // },
  {
    index: 161,
    label: i18n.t('Oman'),
    phoneAreaCode: 968,
    labelKey: 'Oman',
    newIndex: 161,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 162,
    label: i18n.t('Palau'),
    phoneAreaCode: 680,
    labelKey: 'Palau',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 163,
    label: i18n.t('Pakistan'),
    phoneAreaCode: 92,
    labelKey: 'Pakistan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 164,
    label: i18n.t('Palestine'),
    phoneAreaCode: 970,
    labelKey: 'Palestine',
    newIndex: 164,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 165,
    label: i18n.t('Panama'),
    phoneAreaCode: 507,
    labelKey: 'Panama',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 166,
    label: i18n.t('PapuaNewGuinea'),
    phoneAreaCode: 675,
    labelKey: 'PapuaNewGuinea',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 167,
    label: i18n.t('Paraguay'),
    phoneAreaCode: 595,
    labelKey: 'Paraguay',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 168,
    label: i18n.t('Peru'),
    phoneAreaCode: 51,
    labelKey: 'Peru',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 169,
    label: i18n.t('Philippines'),
    phoneAreaCode: 63,
    labelKey: 'Philippines',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 170,
    label: i18n.t('PuertoRico'),
    phoneAreaCode: 1,
    labelKey: 'PuertoRico',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 171,
    label: i18n.t('Qatar'),
    phoneAreaCode: 974,
    labelKey: 'Qatar',
    newIndex: 171,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 172,
    label: i18n.t('Russia'),
    phoneAreaCode: 7,
    labelKey: 'Russia',
    newIndex: 172,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158253045876482&receiveId=&sourceId=209&lan=en'
  },
  {
    index: 173,
    label: i18n.t('Rwanda'),
    phoneAreaCode: 250,
    labelKey: 'Rwanda',
    newIndex: 173,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 174,
    label: i18n.t('SaintBarthelemy'),
    phoneAreaCode: 590,
    labelKey: 'SaintBarthelemy',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 175,
    label: i18n.t('SaintKittsAndNevis'),
    phoneAreaCode: 1869,
    labelKey: 'SaintKittsAndNevis',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 176,
    label: i18n.t('SaintLucia'),
    phoneAreaCode: 1758,
    labelKey: 'SaintLucia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 177,
    label: i18n.t('SaintMartin_FrenchPart'),
    phoneAreaCode: 590,
    labelKey: 'SaintMartin_FrenchPart',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 178,
    label: i18n.t('SaintPierreAndMiquelon'),
    phoneAreaCode: 508,
    labelKey: 'SaintPierreAndMiquelon',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 179,
    label: i18n.t('SaintVincentAndTheGrenadines'),
    phoneAreaCode: 1784,
    labelKey: 'SaintVincentAndTheGrenadines',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 180,
    label: i18n.t('Samoa'),
    phoneAreaCode: 685,
    labelKey: 'Samoa',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 181,
    label: i18n.t('SanMarino'),
    phoneAreaCode: 378,
    labelKey: 'SanMarino',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 182,
    label: i18n.t('SaoTomeAndPrincipe'),
    phoneAreaCode: 239,
    labelKey: 'SaoTomeAndPrincipe',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 183,
    label: i18n.t('SaudiArabia'),
    phoneAreaCode: 966,
    labelKey: 'SaudiArabia',
    newIndex: 183,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 184,
    label: i18n.t('Senegal'),
    phoneAreaCode: 221,
    labelKey: 'Senegal',
    newIndex: 184,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 185,
    label: i18n.t('Seychelles'),
    phoneAreaCode: 248,
    labelKey: 'Seychelles',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 186,
    label: i18n.t('SierraLeone'),
    phoneAreaCode: 232,
    labelKey: 'SierraLeone',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 187,
    label: i18n.t('Singapore'),
    phoneAreaCode: 65,
    labelKey: 'Singapore',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  // {
  //   index: 188,
  //   label: i18n.t('SintMaarten_DutchPart'),
  //   phoneAreaCode: 1721,
  //   labelKey: "SintMaarten_DutchPart",
  //   robotUrl: "https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en",
  // },
  {
    index: 189,
    label: i18n.t('Somalia'),
    phoneAreaCode: 252,
    labelKey: 'Somalia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 190,
    label: i18n.t('SouthAfrica'),
    phoneAreaCode: 27,
    labelKey: 'SouthAfrica',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 191,
    label: i18n.t('SriLanka'),
    phoneAreaCode: 94,
    labelKey: 'SriLanka',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 192,
    label: i18n.t('Suriname'),
    phoneAreaCode: 597,
    labelKey: 'Suriname',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 193,
    label: i18n.t('Swaziland'),
    phoneAreaCode: 268,
    labelKey: 'Swaziland',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 194,
    label: i18n.t('Tajikistan'),
    phoneAreaCode: 992,
    labelKey: 'Tajikistan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158253045876482&receiveId=&sourceId=209&lan=en'
  },
  {
    index: 195,
    label: i18n.t('Tanzania'),
    phoneAreaCode: 255,
    labelKey: 'Tanzania',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 196,
    label: i18n.t('Taiwan_China'),
    phoneAreaCode: 886,
    labelKey: 'Taiwan_China',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 197,
    label: i18n.t('Thailand'),
    phoneAreaCode: 66,
    labelKey: 'Thailand',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 198,
    label: i18n.t('Timor_Leste'),
    phoneAreaCode: 670,
    labelKey: 'Timor_Leste',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 199,
    label: i18n.t('Togo'),
    phoneAreaCode: 228,
    labelKey: 'Togo',
    newIndex: 199,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 200,
    label: i18n.t('Tonga'),
    phoneAreaCode: 676,
    labelKey: 'Tonga',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 201,
    label: i18n.t('TrinidadAndTobago'),
    phoneAreaCode: 1868,
    labelKey: 'TrinidadAndTobago',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 202,
    label: i18n.t('Tunisia'),
    phoneAreaCode: 216,
    labelKey: 'Tunisia',
    newIndex: 202,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 203,
    label: i18n.t('Turkey'),
    phoneAreaCode: 90,
    labelKey: 'Turkey',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 204,
    label: i18n.t('Turkmenistan'),
    phoneAreaCode: 993,
    labelKey: 'Turkmenistan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1659089775990138&receiveId=&sourceId=253&lan=en'
  },
  {
    index: 205,
    label: i18n.t('TurksAndCaicosIslands'),
    phoneAreaCode: 1649,
    labelKey: 'TurksAndCaicosIslands',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 206,
    label: i18n.t('Uganda'),
    phoneAreaCode: 256,
    labelKey: 'Uganda',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 207,
    label: i18n.t('Ukraine'),
    phoneAreaCode: 380,
    labelKey: 'Ukraine',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 208,
    label: i18n.t('UnitedArabEmirates'),
    phoneAreaCode: 971,
    labelKey: 'UnitedArabEmirates',
    newIndex: 208,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=268&lan=en'
  },
  {
    index: 210,
    label: i18n.t('Uruguay'),
    phoneAreaCode: 598,
    labelKey: 'Uruguay',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 211,
    label: i18n.t('Uzbekistan'),
    phoneAreaCode: 998,
    labelKey: 'Uzbekistan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158253045876482&receiveId=&sourceId=209&lan=en'
  },
  {
    index: 212,
    label: i18n.t('Vanuatu'),
    phoneAreaCode: 678,
    labelKey: 'Vanuatu',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 213,
    label: i18n.t('Vatican'),
    phoneAreaCode: 39,
    labelKey: 'Vatican',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 214,
    label: i18n.t('Venezuela'),
    phoneAreaCode: 58,
    labelKey: 'Venezuela',
    robotUrl: 'https://hik-e.hikccs.com/s/hikvisionlatambot'
  },
  {
    index: 215,
    label: i18n.t('Vietnam'),
    phoneAreaCode: 84,
    labelKey: 'Vietnam',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1643341872848127&receiveId=&sourceId=252&lan=en'
  },
  {
    index: 216,
    label: i18n.t('VirginIslands_British'),
    phoneAreaCode: 1284,
    labelKey: 'VirginIslands_British',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 217,
    label: i18n.t('VirginIslands_US'),
    phoneAreaCode: 1340,
    labelKey: 'VirginIslands_US',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 218,
    label: i18n.t('Yemen'),
    phoneAreaCode: 967,
    labelKey: 'Yemen',
    newIndex: 218,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=159290006658994&receiveId=&sourceId=216&lan=en'
  },
  {
    index: 219,
    label: i18n.t('Zambia'),
    phoneAreaCode: 260,
    labelKey: 'Zambia',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 220,
    label: i18n.t('Zimbabwe'),
    phoneAreaCode: 263,
    labelKey: 'Zimbabwe',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 221,
    label: i18n.t('NorthernMarianaIslands'),
    phoneAreaCode: 1,
    labelKey: 'NorthernMarianaIslands',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 222,
    label: i18n.t('Guam'),
    phoneAreaCode: 1,
    labelKey: 'Guam',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 223,
    label: i18n.t('AmericanSamoa'),
    phoneAreaCode: 1,
    labelKey: 'AmericanSamoa',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 224,
    label: i18n.t('BritishIndianOceanTerritory'),
    phoneAreaCode: 246,
    labelKey: 'BritishIndianOceanTerritory',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 225,
    label: i18n.t('Sudan'),
    phoneAreaCode: 249,
    labelKey: 'Sudan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 226,
    label: i18n.t('Mayotte'),
    phoneAreaCode: 262,
    labelKey: 'Mayotte',
    newIndex: 226,
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=224&lan=en'
  },
  {
    index: 227,
    label: i18n.t('SaintHelena'),
    phoneAreaCode: 290,
    labelKey: 'SaintHelena',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 228,
    label: i18n.t('FaroeIslands'),
    phoneAreaCode: 298,
    labelKey: 'FaroeIslands',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 289,
    label: i18n.t('Gibraltar'),
    phoneAreaCode: 350,
    labelKey: 'Gibraltar',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 290,
    label: i18n.t('NorfolkIsland'),
    phoneAreaCode: 672,
    labelKey: 'NorfolkIsland',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 291,
    label: i18n.t('SolomonIslands'),
    phoneAreaCode: 677,
    labelKey: 'SolomonIslands',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 292,
    label: i18n.t('Niue'),
    phoneAreaCode: 683,
    labelKey: 'Niue',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 293,
    label: i18n.t('WallisandFutuna'),
    phoneAreaCode: 681,
    labelKey: 'WallisandFutuna',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 294,
    label: i18n.t('Tuvalu'),
    phoneAreaCode: 688,
    labelKey: 'Tuvalu',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 295,
    label: i18n.t('Tokelau'),
    phoneAreaCode: 690,
    labelKey: 'Tokelau',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 297,
    label: i18n.t('UnitedKingdom'),
    phoneAreaCode: 44,
    labelKey: 'UnitedKingdom',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 308,
    label: i18n.t('SouthSudan'),
    phoneAreaCode: 211,
    labelKey: 'SouthSudan',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=1476067342641247&receiveId=&sourceId=211&lan=en'
  },
  {
    index: 309,
    label: i18n.t('Reunion'),
    phoneAreaCode: 262,
    labelKey: 'Reunion',
    robotUrl:
      'https://international-robot.hikvision.com/robot/h5chat.html?sysNum=158943905831586&receiveId=&sourceId=219&lan=en'
  }
];
const othersCountries = [
  {
    index: 26,
    label: i18n.t('AfricaOther'),
    phoneAreaCode: 0,
    labelKey: 'AfricaOther'
  },
  {
    index: 37,
    label: i18n.t('Asia'),
    phoneAreaCode: 0,
    labelKey: 'Asia'
  },
  {
    index: 38,
    label: i18n.t('AsiaOther'),
    phoneAreaCode: 0,
    labelKey: 'AsiaOther'
  },
  {
    index: 86,
    label: i18n.t('EuropeOther'),
    phoneAreaCode: 0,
    labelKey: 'EuropeOther'
  },
  {
    index: 160,
    label: i18n.t('OceaniaOther'),
    phoneAreaCode: 0,
    labelKey: 'OceaniaOther'
  },
  {
    index: 296,
    label: i18n.t('Syria'),
    phoneAreaCode: 963,
    labelKey: 'Syria'
  }
];
const getCountries = (needOthersCountries = false) => {
  CountriesItem.sort((a, b) => a['label'].localeCompare(b['label']));
  let allCountries = [...CountriesItem];
  if (needOthersCountries) {
    allCountries = allCountries.concat(...othersCountries);
  }
  return allCountries;
};
const GetOthersCountries = () => {
  return {
    26: {
      index: 26,
      label: i18n.t('AfricaOther'),
      phoneAreaCode: 0,
      labelKey: 'AfricaOther'
    },
    37: {
      index: 37,
      label: i18n.t('Asia'),
      phoneAreaCode: 0,
      labelKey: 'Asia'
    },
    38: {
      index: 38,
      label: i18n.t('AsiaOther'),
      phoneAreaCode: 0,
      labelKey: 'AsiaOther'
    },
    86: {
      index: 86,
      label: i18n.t('EuropeOther'),
      phoneAreaCode: 0,
      labelKey: 'EuropeOther'
    },
    160: {
      index: 160,
      label: i18n.t('OceaniaOther'),
      phoneAreaCode: 0,
      labelKey: 'OceaniaOther'
    }
  };
};
const getTimeZone = () => {
  const TimeZoneItem = [
    {
      index: 262,
      label: i18n.t('timezone_262'),
      offset: 5,
      labelKey: 'timezone_262'
    },
    {
      index: 261,
      label: i18n.t('timezone_261'),
      offset: 4,
      labelKey: 'timezone_261'
    },
    {
      index: 254,
      label: i18n.t('timezone_254'),
      offset: -12,
      labelKey: 'timezone_254'
    },
    {
      index: 253,
      label: i18n.t('timezone_253'),
      offset: -11,
      labelKey: 'timezone_253'
    },
    {
      index: 252,
      label: i18n.t('timezone_252'),
      offset: -10,
      labelKey: 'timezone_252'
    },
    {
      index: 251,
      label: i18n.t('timezone_251'),
      offset: -9.5,
      labelKey: 'timezone_251'
    },
    {
      index: 249,
      label: i18n.t('timezone_249'),
      offset: -9,
      labelKey: 'timezone_249'
    },
    {
      index: 248,
      label: i18n.t('timezone_248'),
      offset: -8,
      labelKey: 'timezone_248'
    },
    {
      index: 247,
      label: i18n.t('timezone_247'),
      offset: -7,
      labelKey: 'timezone_247'
    },
    {
      index: 246,
      label: i18n.t('timezone_246'),
      offset: -6,
      labelKey: 'timezone_246'
    },
    {
      index: 245,
      label: i18n.t('timezone_245'),
      offset: -6,
      labelKey: 'timezone_245'
    },
    {
      index: 244,
      label: i18n.t('timezone_244'),
      offset: -6,
      labelKey: 'timezone_244'
    },
    {
      index: 243,
      label: i18n.t('timezone_243'),
      offset: -6,
      labelKey: 'timezone_243'
    },
    {
      index: 242,
      label: i18n.t('timezone_242'),
      offset: -5,
      labelKey: 'timezone_242'
    },
    {
      index: 241,
      label: i18n.t('timezone_241'),
      offset: -5,
      labelKey: 'timezone_241'
    },
    {
      index: 240,
      label: i18n.t('timezone_240'),
      offset: -5,
      labelKey: 'timezone_240'
    },
    {
      index: 239,
      label: i18n.t('timezone_239'),
      offset: -5,
      labelKey: 'timezone_239'
    },
    {
      index: 238,
      label: i18n.t('timezone_238'),
      offset: -5,
      labelKey: 'timezone_238'
    },
    {
      index: 237,
      label: i18n.t('timezone_237'),
      offset: -4,
      labelKey: 'timezone_237'
    },
    {
      index: 236,
      label: i18n.t('timezone_236'),
      offset: -4,
      labelKey: 'timezone_236'
    },
    {
      index: 235,
      label: i18n.t('timezone_235'),
      offset: -4,
      labelKey: 'timezone_235'
    },
    {
      index: 234,
      label: i18n.t('timezone_234'),
      offset: -4,
      labelKey: 'timezone_234'
    },
    {
      index: 233,
      label: i18n.t('timezone_233'),
      offset: -4,
      labelKey: 'timezone_233'
    },
    {
      index: 232,
      label: i18n.t('timezone_232'),
      offset: -4,
      labelKey: 'timezone_232'
    },
    {
      index: 231,
      label: i18n.t('timezone_231'),
      offset: -3.5,
      labelKey: 'timezone_231'
    },
    {
      index: 230,
      label: i18n.t('timezone_230'),
      offset: -3,
      labelKey: 'timezone_230'
    },
    {
      index: 229,
      label: i18n.t('timezone_229'),
      offset: -3,
      labelKey: 'timezone_229'
    },
    {
      index: 228,
      label: i18n.t('timezone_228'),
      offset: -3,
      labelKey: 'timezone_228'
    },
    {
      index: 227,
      label: i18n.t('timezone_227'),
      offset: -3,
      labelKey: 'timezone_227'
    },
    {
      index: 226,
      label: i18n.t('timezone_226'),
      offset: -3,
      labelKey: 'timezone_226'
    },
    {
      index: 225,
      label: i18n.t('timezone_225'),
      offset: -3,
      labelKey: 'timezone_225'
    },
    {
      index: 224,
      label: i18n.t('timezone_224'),
      offset: -3,
      labelKey: 'timezone_224'
    },
    {
      index: 223,
      label: i18n.t('timezone_223'),
      offset: -3,
      labelKey: 'timezone_223'
    },
    {
      index: 222,
      label: i18n.t('timezone_222'),
      offset: -3,
      labelKey: 'timezone_222'
    },
    {
      index: 221,
      label: i18n.t('timezone_221'),
      offset: -2,
      labelKey: 'timezone_221'
    },
    {
      index: 220,
      label: i18n.t('timezone_220'),
      offset: -2,
      labelKey: 'timezone_220'
    },
    {
      index: 219,
      label: i18n.t('timezone_219'),
      offset: -1,
      labelKey: 'timezone_219'
    },
    {
      index: 218,
      label: i18n.t('timezone_218'),
      offset: -1,
      labelKey: 'timezone_218'
    },
    {
      index: 215,
      label: i18n.t('timezone_215'),
      offset: 13,
      labelKey: 'timezone_215'
    },
    {
      index: 214,
      label: i18n.t('timezone_214'),
      offset: 13,
      labelKey: 'timezone_214'
    },
    {
      index: 213,
      label: i18n.t('timezone_213'),
      offset: 12.75,
      labelKey: 'timezone_213'
    },
    {
      index: 212,
      label: i18n.t('timezone_212'),
      offset: 12,
      labelKey: 'timezone_212'
    },
    {
      index: 211,
      label: i18n.t('timezone_211'),
      offset: 12,
      labelKey: 'timezone_211'
    },
    {
      index: 143,
      label: i18n.t('timezone_143'),
      offset: 2,
      labelKey: 'timezone_143'
    },
    {
      index: 142,
      label: i18n.t('timezone_142'),
      offset: 2,
      labelKey: 'timezone_142'
    },
    {
      index: 141,
      label: i18n.t('timezone_141'),
      offset: 2,
      labelKey: 'timezone_141'
    },
    {
      index: 140,
      label: i18n.t('timezone_140'),
      offset: 2,
      labelKey: 'timezone_140'
    },
    {
      index: 139,
      label: i18n.t('timezone_139'),
      offset: 2,
      labelKey: 'timezone_139'
    },
    {
      index: 138,
      label: i18n.t('timezone_138'),
      offset: 1,
      labelKey: 'timezone_138'
    },
    {
      index: 137,
      label: i18n.t('timezone_137'),
      offset: 1,
      labelKey: 'timezone_137'
    },
    {
      index: 136,
      label: i18n.t('timezone_136'),
      offset: 0,
      labelKey: 'timezone_136'
    },
    {
      index: 209,
      label: i18n.t('timezone_209'),
      offset: 12,
      labelKey: 'timezone_209'
    },
    {
      index: 208,
      label: i18n.t('timezone_208'),
      offset: 12,
      labelKey: 'timezone_208'
    },
    {
      index: 207,
      label: i18n.t('timezone_207'),
      offset: 11,
      labelKey: 'timezone_207'
    },
    {
      index: 206,
      label: i18n.t('timezone_206'),
      offset: 11,
      labelKey: 'timezone_206'
    },
    {
      index: 205,
      label: i18n.t('timezone_205'),
      offset: 11,
      labelKey: 'timezone_205'
    },
    {
      index: 204,
      label: i18n.t('timezone_204'),
      offset: 11,
      labelKey: 'timezone_204'
    },
    {
      index: 203,
      label: i18n.t('timezone_203'),
      offset: 11,
      labelKey: 'timezone_203'
    },
    {
      index: 202,
      label: i18n.t('timezone_202'),
      offset: 11,
      labelKey: 'timezone_202'
    },
    {
      index: 201,
      label: i18n.t('timezone_201'),
      offset: 10.5,
      labelKey: 'timezone_201'
    },
    {
      index: 200,
      label: i18n.t('timezone_200'),
      offset: 10,
      labelKey: 'timezone_200'
    },
    {
      index: 199,
      label: i18n.t('timezone_199'),
      offset: 10,
      labelKey: 'timezone_199'
    },
    {
      index: 198,
      label: i18n.t('timezone_198'),
      offset: 10,
      labelKey: 'timezone_198'
    },
    {
      index: 197,
      label: i18n.t('timezone_197'),
      offset: 10,
      labelKey: 'timezone_197'
    },
    {
      index: 196,
      label: i18n.t('timezone_196'),
      offset: 10,
      labelKey: 'timezone_196'
    },
    {
      index: 195,
      label: i18n.t('timezone_195'),
      offset: 9.5,
      labelKey: 'timezone_195'
    },
    {
      index: 194,
      label: i18n.t('timezone_194'),
      offset: 9.5,
      labelKey: 'timezone_194'
    },
    {
      index: 193,
      label: i18n.t('timezone_193'),
      offset: 9,
      labelKey: 'timezone_193'
    },
    {
      index: 192,
      label: i18n.t('timezone_192'),
      offset: 9,
      labelKey: 'timezone_192'
    },
    {
      index: 191,
      label: i18n.t('timezone_191'),
      offset: 9,
      labelKey: 'timezone_191'
    },
    {
      index: 190,
      label: i18n.t('timezone_190'),
      offset: 9,
      labelKey: 'timezone_190'
    },
    {
      index: 189,
      label: i18n.t('timezone_189'),
      offset: 9,
      labelKey: 'timezone_189'
    },
    {
      index: 188,
      label: i18n.t('timezone_188'),
      offset: 8.75,
      labelKey: 'timezone_188'
    },
    {
      index: 187,
      label: i18n.t('timezone_187'),
      offset: 8,
      labelKey: 'timezone_187'
    },
    {
      index: 186,
      label: i18n.t('timezone_186'),
      offset: 8,
      labelKey: 'timezone_186'
    },
    {
      index: 185,
      label: i18n.t('timezone_185'),
      offset: 8,
      labelKey: 'timezone_185'
    },
    {
      index: 184,
      label: i18n.t('timezone_184'),
      offset: 8,
      labelKey: 'timezone_184'
    },
    {
      index: 183,
      label: i18n.t('timezone_183'),
      offset: 8,
      labelKey: 'timezone_183'
    },
    {
      index: 182,
      label: i18n.t('timezone_182'),
      offset: 8,
      labelKey: 'timezone_182'
    },
    {
      index: 181,
      label: i18n.t('timezone_181'),
      offset: 7,
      labelKey: 'timezone_181'
    },
    {
      index: 180,
      label: i18n.t('timezone_180'),
      offset: 7,
      labelKey: 'timezone_180'
    },
    {
      index: 179,
      label: i18n.t('timezone_179'),
      offset: 7,
      labelKey: 'timezone_179'
    },
    {
      index: 178,
      label: i18n.t('timezone_178'),
      offset: 7,
      labelKey: 'timezone_178'
    },
    {
      index: 177,
      label: i18n.t('timezone_177'),
      offset: 7,
      labelKey: 'timezone_177'
    },
    {
      index: 176,
      label: i18n.t('timezone_176'),
      offset: 7,
      labelKey: 'timezone_176'
    },
    {
      index: 175,
      label: i18n.t('timezone_175'),
      offset: 6.5,
      labelKey: 'timezone_175'
    },
    {
      index: 174,
      label: i18n.t('timezone_174'),
      offset: 6,
      labelKey: 'timezone_174'
    },
    {
      index: 173,
      label: i18n.t('timezone_173'),
      offset: 6,
      labelKey: 'timezone_173'
    },
    {
      index: 172,
      label: i18n.t('timezone_172'),
      offset: 6,
      labelKey: 'timezone_172'
    },
    {
      index: 171,
      label: i18n.t('timezone_171'),
      offset: 5.75,
      labelKey: 'timezone_171'
    },
    {
      index: 170,
      label: i18n.t('timezone_170'),
      offset: 5.5,
      labelKey: 'timezone_170'
    },
    {
      index: 169,
      label: i18n.t('timezone_169'),
      offset: 5.5,
      labelKey: 'timezone_169'
    },
    {
      index: 168,
      label: i18n.t('timezone_168'),
      offset: 5,
      labelKey: 'timezone_168'
    },
    {
      index: 167,
      label: i18n.t('timezone_167'),
      offset: 5,
      labelKey: 'timezone_167'
    },
    {
      index: 166,
      label: i18n.t('timezone_166'),
      offset: 5,
      labelKey: 'timezone_166'
    },
    {
      index: 165,
      label: i18n.t('timezone_165'),
      offset: 4.5,
      labelKey: 'timezone_165'
    },
    {
      index: 164,
      label: i18n.t('timezone_164'),
      offset: 4,
      labelKey: 'timezone_164'
    },
    {
      index: 163,
      label: i18n.t('timezone_163'),
      offset: 4,
      labelKey: 'timezone_163'
    },
    {
      index: 162,
      label: i18n.t('timezone_162'),
      offset: 4,
      labelKey: 'timezone_162'
    },
    {
      index: 161,
      label: i18n.t('timezone_161'),
      offset: 4,
      labelKey: 'timezone_161'
    },
    {
      index: 160,
      label: i18n.t('timezone_160'),
      offset: 4,
      labelKey: 'timezone_160'
    },
    {
      index: 159,
      label: i18n.t('timezone_159'),
      offset: 4,
      labelKey: 'timezone_159'
    },
    {
      index: 158,
      label: i18n.t('timezone_158'),
      offset: 4,
      labelKey: 'timezone_158'
    },
    {
      index: 157,
      label: i18n.t('timezone_157'),
      offset: 4,
      labelKey: 'timezone_157'
    },
    {
      index: 156,
      label: i18n.t('timezone_156'),
      offset: 3.5,
      labelKey: 'timezone_156'
    },
    {
      index: 155,
      label: i18n.t('timezone_155'),
      offset: 3,
      labelKey: 'timezone_155'
    },
    {
      index: 154,
      label: i18n.t('timezone_154'),
      offset: 3,
      labelKey: 'timezone_154'
    },
    {
      index: 153,
      label: i18n.t('timezone_153'),
      offset: 3,
      labelKey: 'timezone_153'
    },
    {
      index: 152,
      label: i18n.t('timezone_152'),
      offset: 3,
      labelKey: 'timezone_152'
    },
    {
      index: 151,
      label: i18n.t('timezone_151'),
      offset: 3,
      labelKey: 'timezone_151'
    },
    {
      index: 150,
      label: i18n.t('timezone_150'),
      offset: 3,
      labelKey: 'timezone_150'
    },
    {
      index: 149,
      label: i18n.t('timezone_149'),
      offset: 2,
      labelKey: 'timezone_149'
    },
    {
      index: 148,
      label: i18n.t('timezone_148'),
      offset: 2,
      labelKey: 'timezone_148'
    },
    {
      index: 147,
      label: i18n.t('timezone_147'),
      offset: 2,
      labelKey: 'timezone_147'
    },
    {
      index: 146,
      label: i18n.t('timezone_146'),
      offset: 2,
      labelKey: 'timezone_146'
    },
    {
      index: 145,
      label: i18n.t('timezone_145'),
      offset: 2,
      labelKey: 'timezone_145'
    },
    {
      index: 118,
      label: i18n.t('timezone_118'),
      offset: 2,
      labelKey: 'timezone_118'
    },
    {
      index: 144,
      label: i18n.t('timezone_144'),
      offset: 2,
      labelKey: 'timezone_144'
    },
    {
      index: 217,
      label: i18n.t('timezone_217'),
      offset: 14,
      labelKey: 'timezone_217'
    },
    {
      index: 216,
      label: i18n.t('timezone_216'),
      offset: 13,
      labelKey: 'timezone_216'
    },
    {
      index: 135,
      label: i18n.t('timezone_135'),
      offset: 0,
      labelKey: 'timezone_135'
    },
    {
      index: 134,
      label: i18n.t('timezone_134'),
      offset: 0,
      labelKey: 'timezone_134'
    },
    {
      index: 133,
      label: i18n.t('timezone_133'),
      offset: 1,
      labelKey: 'timezone_133'
    },
    {
      index: 120,
      label: i18n.t('timezone_120'),
      offset: -7,
      labelKey: 'timezone_120'
    },
    {
      index: 119,
      label: i18n.t('timezone_119'),
      offset: -5,
      labelKey: 'timezone_119'
    },
    {
      index: 90,
      label: i18n.t('timezone_90'),
      offset: 1,
      labelKey: 'timezone_90'
    },
    {
      index: 87,
      label: i18n.t('timezone_87'),
      offset: -8,
      labelKey: 'timezone_87'
    },
    {
      index: 86,
      label: i18n.t('timezone_86'),
      offset: -8,
      labelKey: 'timezone_86'
    },
    {
      index: 72,
      label: i18n.t('timezone_72'),
      offset: -7,
      labelKey: 'timezone_72'
    },
    {
      index: 53,
      label: i18n.t('timezone_53'),
      offset: -10,
      labelKey: 'timezone_53'
    },
    {
      index: 51,
      label: i18n.t('timezone_51'),
      offset: 2,
      labelKey: 'timezone_51'
    },
    {
      index: 48,
      label: i18n.t('timezone_48'),
      offset: 0,
      labelKey: 'timezone_48'
    },
    {
      index: 46,
      label: i18n.t('timezone_46'),
      offset: 2,
      labelKey: 'timezone_46'
    },
    {
      index: 41,
      label: i18n.t('timezone_41'),
      offset: -5,
      labelKey: 'timezone_41'
    },
    {
      index: 30,
      label: i18n.t('timezone_30'),
      offset: -6,
      labelKey: 'timezone_30'
    },
    {
      index: 28,
      label: i18n.t('timezone_28'),
      offset: 1,
      labelKey: 'timezone_28'
    },
    {
      index: 27,
      label: i18n.t('timezone_27'),
      offset: 1,
      labelKey: 'timezone_27'
    },
    {
      index: 2,
      label: i18n.t('timezone_2'),
      offset: -9,
      labelKey: 'timezone_2'
    },
    {
      index: 309,
      label: i18n.t('timezone_309'),
      offset: 4,
      labelKey: 'timezone_309'
    }
  ];
  let leftList = [];
  let rightList = [];
  let centerList = [];
  let zeroUTC = {};
  for (let i = 0; i < TimeZoneItem.length; i++) {
    if (TimeZoneItem[i].index === 136) {
      zeroUTC = TimeZoneItem[i];
      continue;
    }
    if (TimeZoneItem[i].label[4].localeCompare('+') < 0) {
      leftList.push(TimeZoneItem[i]);
    } else if (TimeZoneItem[i].label.split(' ')[0].localeCompare('(UTC+00:00)') > 0) {
      rightList.push(TimeZoneItem[i]);
    } else {
      centerList.push(TimeZoneItem[i]);
    }
  }

  leftList = leftList.sort(function (a, b) {
    if (a['label'].split(' ')[0] === b['label'].split(' ')[0]) {
      return a['label'].localeCompare(b['label']);
    }
    return b['label'].localeCompare(a['label']);
  });

  leftList.push({
    ...zeroUTC
  });

  rightList = rightList.sort(function (a, b) {
    return a['label'].localeCompare(b['label']);
  });

  centerList = centerList.sort(function (a, b) {
    return a['label'].localeCompare(b['label']);
  });

  return leftList.concat(centerList, rightList);
};
const countryFlagCorrespond = {
  AF: 25,
  AL: 27,
  DZ: 28,
  AS: 223,
  AD: 29,
  AO: 30,
  AI: 31,
  AQ: 32,
  AG: 33,
  AR: 34,
  AM: 35,
  AW: 36,
  AU: 39,
  AT: 0,
  AZ: 40,
  BS: 41,
  BH: 42,
  BD: 43,
  BB: 44,
  BY: 45,
  BE: 1,
  BZ: 46,
  BJ: 47,
  BM: 48,
  BT: 49,
  BO: 50,
  BQ: 51,
  BA: 52,
  BW: 53,
  BR: 54,
  IO: 224,
  BN: 55,
  BG: 56,
  BF: 57,
  MM: 58,
  BI: 59,
  KH: 60,
  CM: 61,
  CA: 24,
  CV: 62,
  KY: 63,
  CF: 64,
  TD: 65,
  CL: 66,
  CN: 133,
  CO: 67,
  KM: 68,
  CG: 69,
  CD: 70,
  CK: 71,
  CR: 72,
  CI: 73,
  HR: 2,
  CW: 74,
  CY: 75,
  CZ: 3,
  DK: 4,
  DJ: 76,
  DM: 77,
  DO: 78,
  EC: 79,
  EG: 80,
  SV: 81,
  GQ: 82,
  ER: 83,
  EE: 84,
  ET: 85,
  FK: 87,
  FO: 228,
  FJ: 88,
  FI: 5,
  FR: 6,
  GF: 89,
  PF: 90,
  GA: 91,
  GM: 92,
  GE: 93,
  DE: 7,
  GH: 94,
  GI: 289,
  GR: 8,
  GL: 95,
  GD: 96,
  GP: 97,
  GU: 222,
  GT: 98,
  GN: 99,
  GW: 100,
  GY: 101,
  HT: 102,
  HN: 103,
  HK: 104,
  HU: 9,
  IS: 105,
  IN: 106,
  ID: 107,
  IQ: 108,
  IE: 109,
  IL: 110,
  IT: 10,
  JM: 111,
  JP: 112,
  JO: 113,
  KZ: 114,
  KE: 115,
  KI: 116,
  KR: 117,
  XK: 118,
  KW: 119,
  KG: 120,
  LA: 121,
  LV: 122,
  LB: 123,
  LS: 124,
  LR: 125,
  LY: 126,
  LI: 127,
  LT: 128,
  LU: 129,
  MO: 130,
  MG: 132,
  MW: 135,
  MY: 134,
  MV: 136,
  ML: 137,
  MT: 138,
  MH: 139,
  MQ: 140,
  MR: 141,
  MU: 142,
  YT: 226,
  MX: 143,
  FM: 144,
  MD: 145,
  MC: 146,
  MN: 147,
  ME: 148,
  MS: 149,
  MA: 150,
  MZ: 151,
  NA: 152,
  NR: 153,
  NP: 154,
  NL: 11,
  NC: 155,
  NZ: 156,
  NI: 157,
  NE: 158,
  NG: 159,
  NU: 292,
  NF: 290,
  MK: 131,
  MP: 221,
  NO: 12,
  OM: 161,
  PK: 163,
  PW: 162,
  PS: 164,
  PA: 165,
  PG: 166,
  PY: 167,
  PE: 168,
  PH: 169,
  PL: 13,
  PT: 14,
  PR: 170,
  QA: 171,
  RO: 15,
  RU: 172,
  RW: 173,
  SH: 227,
  LC: 176,
  MF: 177,
  BL: 174,
  KN: 175,
  PM: 178,
  VC: 179,
  WS: 180,
  SM: 181,
  ST: 182,
  SA: 183,
  SN: 184,
  RS: 16,
  RE: 309,
  SC: 185,
  SL: 186,
  SG: 187,
  SX: 188,
  SK: 17,
  SI: 18,
  SB: 291,
  SO: 189,
  ZA: 190,
  ES: 19,
  LK: 191,
  SD: 225,
  SR: 192,
  SS: 308,
  SZ: 193,
  SE: 20,
  CH: 21,
  SY: 296,
  TW: 196,
  TJ: 194,
  TZ: 195,
  TH: 197,
  TL: 198,
  TG: 199,
  TK: 295,
  TO: 200,
  TT: 201,
  TN: 202,
  TR: 203,
  TM: 204,
  TC: 205,
  TV: 294,
  UG: 206,
  UA: 207,
  AE: 208,
  GB: 22,
  US: 23,
  UY: 210,
  UZ: 211,
  VU: 212,
  VA: 213,
  VE: 214,
  VN: 215,
  VG: 216,
  VI: 217,
  WF: 293,
  YE: 218,
  ZM: 219,
  ZW: 220
};

const getCountryByIndex = function (countryIndex) {
  let target = '';
  // eslint-disable-next-line new-cap
  const Countries = getCountries(true, true);
  for (let i = 0; i < Countries.length; i++) {
    if (parseInt(countryIndex, 10) === Countries[i].index) {
      target = i18n.t(Countries[i].labelKey);
      break;
    }
  }
  return target;
};

const getMyTimeZoneOffset = function () {
  let start = new Date();
  start.setMonth(0);
  start.setDate(1);
  start.setHours(0);
  start.setMinutes(0);
  start.setSeconds(0);
  let iStartOffset = start.getTimezoneOffset();

  let middle = new Date(start.getTime());
  middle.setMonth(6);
  let iMiddleOffset = middle.getTimezoneOffset();
  if (iStartOffset !== iMiddleOffset) {
    return iStartOffset > iMiddleOffset ? iStartOffset : iMiddleOffset;
  }
  return iStartOffset;
};

const getMyTimeZoneIndex = function () {
  const offset = -getMyTimeZoneOffset() / 60;
  // eslint-disable-next-line new-cap
  let TimeZoneItem = getTimeZone();
  return _.find(TimeZoneItem, (t) => {
    return t.offset === offset;
  }).index;
};

const getCountryIndexByTelCode = function (code) {
  if (code === 1) {
    return {
      index: 23,
      label: i18n.t('UnitedStates'),
      phoneAreaCode: 1
    };
  }
  // eslint-disable-next-line new-cap
  return getCountries(true).find((country) => country.phoneAreaCode === code);
};

const getCountryIndexByFlag = function (flag) {
  // 返回前过一遍是否在国家列表中，不在的话返回-1
  // eslint-disable-next-line new-cap
  if (!isNaN(+flag) && typeof +flag === 'number') {
    return flag;
  }
  const country = getCountries().find((item) => {
    return item.index === countryFlagCorrespond[flag];
  });
  return country ? country.index : -1;
};
const getFlagByCountryIndex = function (index) {
  for (const key in countryFlagCorrespond) {
    if (countryFlagCorrespond[key] === +index) {
      return key;
    }
  }
};
const indexValueCheck = function (index) {
  index = parseInt(index, 10);
  // eslint-disable-next-line new-cap
  return _.find(getCountries(), (country) => {
    return country.index === index;
  })
    ? index
    : '';
};

/*获取全量的国家信息，主要用于电话区域，获取国家列表不要使用*/
const getGlobalPhoneArea = () => {
  return [...CountriesItem, ...othersCountries];
};

/**
 * 根据国家跳转不同问答机器人地址
 * @param index 用户账号所处国家
 * @return {string} 问答机器人跳转地址
 */
const getRobotUrl = (index) => {
  const robotUrl
    = 'https://international-chat.hikvision.com/webchat/index.html?appKey=af90eed80113af969375513b8b4fae59##msg18';
  const list = CountriesItem.filter((item) => {
    let countryIndex = item.newIndex || item.index;
    return countryIndex === parseInt(index, 10);
  });
  return list ? list[0].robotUrl || robotUrl : robotUrl;
};

const getTPPUrl = (index) => {
  const TPPUrl = 'https://tpp.hikvision.com';
  const list = CountriesItem.filter((item) => {
    let countryIndex = item.newIndex || item.index;
    return countryIndex === parseInt(index, 10);
  });
  return list ? list[0]?.TPPUrl || TPPUrl : TPPUrl;
};

const getELearningUrl = (index) => {
  const eLearningUrl = 'https://elearning.hikvision.com/en';
  const list = CountriesItem.filter((item) => {
    let countryIndex = item.newIndex || item.index;
    return countryIndex === parseInt(index, 10);
  });
  return list ? list[0].eLearningUrl || eLearningUrl : eLearningUrl;
};

const getFAQUrl = (index) => {
  const FAQUrl = 'http://enpinfodata.hikvision.com/analysisQR/showQR/7ac0a157.html';
  const list = CountriesItem.filter((item) => {
    let countryIndex = item.newIndex || item.index;
    return countryIndex === parseInt(index, 10);
  });
  return list ? list[0].FAQUrl || FAQUrl : FAQUrl;
};

const getYoutubeLink = (index) => {
  const youtubeLink = 'https://www.youtube.com/channel/UCfn2t5cHA0QawA7_OqlfFMw';
  const list = CountriesItem.filter((item) => {
    let countryIndex = item.newIndex || item.index;
    return countryIndex === parseInt(index, 10);
  });
  return list ? list[0].youtubeLink || youtubeLink : youtubeLink;
};

function formatTimezoneOffset(offset) {
  var sign = offset >= 0 ? '-' : '+';
  offset = Math.abs(offset);
  var hours = Math.floor(offset / 60);
  var minutes = offset % 60;

  // 格式化输出时区偏移量
  var formattedOffset = `${sign + pad(hours, 2)}:${pad(minutes, 2)}`;
  return `(UTC${formattedOffset}) `;
}

function pad(num, size) {
  var s = `${num}`;
  while (s.length < size) {
    s = `0${s}`;
  }
  return s;
}

// 新时区数据返回，原本地维护的时区列表不再使用
async function getHcbTimezone(locale) {
  try {
    const [data, err] = await getTimezone();

    if (data) {
      const timezones = _.sortBy(data.timezones, [
        (o) => {
          return -o.bias;
        },
        'displayName'
      ]);
      mutations.setTimezone(timezones);
      const result = await getSiteTimeZoneTxt({ locale, timestamp: Date.now() });
      if (result[0]?.translateContentList[0]?.dataInfos) {
        timezones.forEach((z) => {
          if (z.id && result[0].translateContentList[0].dataInfos[`ccfdic.timezonev2.${z.id}.name`]) {
            z.displayName
              = formatTimezoneOffset(z.bias)
              + result[0].translateContentList[0].dataInfos[`ccfdic.timezonev2.${z.id}.name`];
          }
        });
      }
      return timezones;
    }
    if (err) {
      return [];
    }
  } catch {
    return [];
  }
}

export {
  getCountries,
  GetOthersCountries,
  getTimeZone,
  getCountryByIndex,
  getMyTimeZoneOffset,
  getMyTimeZoneIndex,
  getCountryIndexByTelCode,
  indexValueCheck,
  getCountryIndexByFlag,
  getFlagByCountryIndex,
  getGlobalPhoneArea,
  getRobotUrl,
  getTPPUrl,
  getELearningUrl,
  getFAQUrl,
  getYoutubeLink,
  getHcbTimezone
};
